import BreadcrumbsHeader from 'client/app/components/nav/breadcrumbs/BreadcrumbsHeader';

const PlatformHeader = BreadcrumbsHeader;

export default PlatformHeader;
